module.exports = __webpack_public_path__ + "img/D201706_4.8f795951.jpg";